import { render, staticRenderFns } from "./reg_address_question.vue?vue&type=template&id=36e974be&"
import script from "./reg_address_question.vue?vue&type=script&lang=js&"
export * from "./reg_address_question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports